import React from 'react';

const AbaFaturaPix = () => {
  return (
    <div className="form-section">
      <h2 className="form-title">Fatura e pagamento via Pix</h2>
      <p>Confira abaixo as informações da sua última fatura:</p>

      <div className="card-options mt-4">
        <p><strong>Valor:</strong> R$ 59,90</p>
        <p><strong>Vencimento:</strong> 10/08/2025</p>
        <p><strong>Status:</strong> Em aberto</p>
      </div>

      <div className="mt-6">
        <button className="submit-button">
          Gerar QR Code Pix
        </button>
      </div>
    </div>
  );
};

export default AbaFaturaPix;
